export default __webpack_public_path__ + "static/media/c-teile-sortiment.6a45a694.webp";